import { useEffect, memo, useState } from 'react';
import { initItem, Item } from '../../mechanics/items/Item';
import { userSlice } from '../../store/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '../../store/store';
import InventoryCurrensyItem from './InventoryCurrensyItem';
import InventoryItem from './InventoryItem';

interface IInventoryBodyProps {
    setPlayerHp?: React.Dispatch<React.SetStateAction<number>>
}

const InventoryBody = ({ setPlayerHp }: IInventoryBodyProps) => {
    // redux const
    const dispatch = useAppDispatch()
    const characterInventory = useAppSelector(state => state.userReducer.character.getInventory())
    const inventoryLength = useAppSelector(state => state.userReducer.character.getInventory().getItems().length)
    const { setInventoryLength } = userSlice.actions
    const showCurrensy = useAppSelector(state => state.userReducer.showCurrensy)
    // other const
    const emptyItem = new Item(initItem)
    const emptyInventorySquares = Array(25 - inventoryLength).fill(emptyItem)
    const currentInventory: Item[] = [...characterInventory.getItems(), ...emptyInventorySquares]

    const classNameIfShowCurrensy = showCurrensy ? 'currensy' : ''

    // ! do not delete const in next line. Alert костЫль!!!)))))
    const isEquipmentChange = useAppSelector(state => state.userReducer.isEquipmentChange)

    useEffect(() => {
        dispatch(setInventoryLength())
    }, [isEquipmentChange])

    return (
        <ul className={`inventory__body-items ${classNameIfShowCurrensy}`}>
            {showCurrensy ?
                <>
                    {Object.keys(characterInventory.getCurrensies()).map(key => {
                            return (
                                <InventoryCurrensyItem
                                    item={characterInventory.getCurrensies()[key]}
                                    key={crypto.randomUUID()}
                                />
                            )
                        
                    })}
                </>
                :
                <>
                    {
                        currentInventory.map((item, i) => {
                            return (
                                <InventoryItem
                                    item={item}
                                    key={crypto.randomUUID()}
                                    index={i}
                                    setPlayerHp={setPlayerHp} />
                            )
                        })
                    }
                </>
            }
        </ul>
    );
};

export default memo(InventoryBody);